import { Span, Div, Text, Button } from "@tblabs/truffle";
import { ByteUtils } from "../Services/ByteUtils";
import { DeviceMenuWindow } from "./../Windows/DeviceMenuWindow";
import { PasswordLabel } from "./PasswordLabel";
import { HotspotIcon } from "./HotspotIcon";
import { DeviceConnectionStatusIcon } from "./DeviceConnectionStatusIcon";
import { UrlBuilder } from "../Services/UrlBuilder";
import { DeviceWatchersWindow } from "../Windows/DeviceWatchersWindow";
import { DevicePicture } from "./DevicePicture";
import { Device } from "../Services/Device";
import { HotspotType } from "../Services/HotspotType";


export class DeviceBox extends Div
{
    constructor(device: Device)
    {
        super();
        this.Class("DeviceBox");
        this.OnClick(() => new DeviceMenuWindow(device));

        if (device.IsAtHome)
        {
            this.Background("#85e78575");
        }

        this.Append(
            device.IsPrivate && new Span("private").Class("uk-badge uk-badge-warning")
                .PositionAbsolute().Top(8).Right(8),
            new DeviceConnectionStatusIcon(device),
            new Span(device.Id).Class("id").CursorPointer()
                .OnClick(() => window.open(UrlBuilder.WatcherPage(device))),
            (device.Hotspot.Type != HotspotType.Unknown) && new HotspotIcon(device.Hotspot),
            device.Version && new Span(device.Version).Class("uk-badge")
                .Background("#ccc").Margin(6).FloatLeft(),
            new Div().Append(
                new PasswordLabel(device.Password),
            ),
            new Div("picture-box").Append(
                new DevicePicture(device.Thumbnail, device.PictureInfo),
                new Button("↻", async btn =>
                {
                    btn.Label("Refreshing...").FontSize(14).Disabled();
                    await device.GetCurrentProfile()
                        ? btn.RestoreInitialLabel().FontSize(64).Enabled()
                        : btn.Label("Failed to refresh").FontSize(14).Disabled();
                }).Class("refresh-btn"),
            ),
            new Div("counters").Append(
                new Text(device.Watchers.CountRef, v => "👀 " + v)
                    .Class("watchers-count")
                    .OnClick(() => new DeviceWatchersWindow(device)),
                new Text(device.Stats.PicturesCount, v => "🖼️ " + v)
                    .Class("pictures-count"),
                new Text(device.Stats.PicturesSize, v => ByteUtils.HumanReadable(+v))
                    .Class("pictures-size"),
                new Text(device.Stats.RebootsCount, v => "⚡" + v)
                    .Class("reboots-count"),
            ),
        );
    }
}
